/**
 * 分组授权权限树（按真实前台导航 / 后台菜单与功能编排）。
 * type: 'perm' = 权限点；type: 'folder' = 仅分组展示。
 *
 * 「未归类」只应出现真正未知的库内权限点；历史兼容项放在 LEGACY 树中展示。
 */

/** 前台：与 App 导航顺序一致，指挥系统下挂操作级权限 */
export const FRONTEND_PERMISSION_TREE = [
  {
    key: 'fe-command',
    title: '指挥系统',
    type: 'folder',
    children: [
      { key: 'fe-command-page', title: '进入指挥系统页面', type: 'perm', name: '指挥系统页面' },
      {
        key: 'fe-command-track',
        title: '轨迹能力',
        type: 'folder',
        children: [
          { key: 'fe-cmd-fetch', title: '获取轨迹（上图）', type: 'perm', name: '指挥系统-获取轨迹' },
          { key: 'fe-cmd-view', title: '查看/隐藏轨迹', type: 'perm', name: '指挥系统-查看轨迹' },
          { key: 'fe-cmd-download', title: '下载轨迹', type: 'perm', name: '指挥系统-下载轨迹' },
          { key: 'fe-cmd-export', title: '导出轨迹（GPX/KML）', type: 'perm', name: '指挥系统-导出轨迹' },
          { key: 'fe-cmd-playback', title: '轨迹回放', type: 'perm', name: '指挥系统-轨迹回放' },
          { key: 'fe-cmd-realtime', title: '实时绘制轨迹', type: 'perm', name: '指挥系统-实时绘制' }
        ]
      },
      {
        key: 'fe-command-board',
        title: '地图画板',
        type: 'folder',
        children: [
          { key: 'fe-cmd-board', title: '使用画板工具', type: 'perm', name: '指挥系统-地图画板' },
          { key: 'fe-cmd-board-push', title: '画板推送队员', type: 'perm', name: '指挥系统-画板推送' }
        ]
      },
      {
        key: 'fe-command-ortho',
        title: '航拍建模',
        type: 'folder',
        children: [
          { key: 'fe-ortho-manage', title: '航拍建模工具箱', type: 'perm', name: '航拍建模' },
          { key: 'fe-ortho-approve', title: '航拍建模审批', type: 'perm', name: '航拍建模审批' },
          { key: 'fe-ortho-view', title: '航拍图层查看', type: 'perm', name: '航拍图层查看' }
        ]
      },
      {
        key: 'fe-command-panorama',
        title: '全景影像',
        type: 'folder',
        children: [
          { key: 'fe-panorama-manage', title: '全景影像管理', type: 'perm', name: '全景影像管理' },
          { key: 'fe-panorama-view', title: '全景影像查看', type: 'perm', name: '全景影像查看' }
        ]
      },
      {
        key: 'fe-command-map-layers',
        title: '地图图层（路网/等高线）',
        type: 'folder',
        children: [
          { key: 'fe-map-layer-manage', title: '地图图层管理', type: 'perm', name: '地图图层管理' },
          { key: 'fe-map-layer-view', title: '地图图层查看', type: 'perm', name: '地图图层查看' }
        ]
      },
      {
        key: 'fe-command-ops',
        title: '其它操作',
        type: 'folder',
        children: [
          { key: 'fe-cmd-basemap', title: '底图切换', type: 'perm', name: '指挥系统-底图切换' },
          { key: 'fe-cmd-command', title: '队员指令下达/接收', type: 'perm', name: '指挥系统-队员指令' },
          { key: 'fe-cmd-mission-board', title: '任务看板编辑（编组/加人）', type: 'perm', name: '指挥系统-任务看板编辑' },
          { key: 'fe-cmd-view-all', title: '查看全部队员（跨组织）', type: 'perm', name: '指挥系统-查看全部队员' },
          { key: 'fe-cmd-view-scoped', title: '查看授权组织队员（仅可见范围）', type: 'perm', name: '指挥系统-查看授权组织队员' },
          { key: 'fe-cmd-notes', title: '队员备注（本人）', type: 'perm', name: '指挥系统-队员备注' },
          { key: 'fe-pick-delete', title: '手机选点删除', type: 'perm', name: '手机选点删除' }
        ]
      }
    ]
  },
  {
    key: 'fe-tools',
    title: '工具下载',
    type: 'folder',
    children: [
      { key: 'fe-tools-page', title: '工具下载页面', type: 'perm', name: '工具下载' }
    ]
  },
  {
    key: 'fe-coordinate',
    title: '坐标转换',
    type: 'folder',
    children: [
      { key: 'fe-coord-page', title: '坐标转换页面', type: 'perm', name: '坐标转换' },
      { key: 'fe-coord-history', title: '查看他人转换历史', type: 'perm', name: '坐标转换历史记录查看' }
    ]
  },
  {
    key: 'fe-history',
    title: '轨迹查询',
    type: 'folder',
    children: [
      { key: 'fe-history-page', title: '轨迹查询页面', type: 'perm', name: '轨迹查询' }
    ]
  },
  {
    key: 'fe-rescue',
    title: '救援推送',
    type: 'folder',
    children: [
      { key: 'fe-rescue-page', title: '救援推送页面', type: 'perm', name: '救援推送' },
      { key: 'fe-rescue-hist-view', title: '推送历史查看', type: 'perm', name: '救援推送历史查看' },
      { key: 'fe-rescue-hist-del', title: '推送历史删除', type: 'perm', name: '救援推送历史删除' },
      { key: 'fe-token-view', title: 'App 令牌查看', type: 'perm', name: '令牌查看' },
      { key: 'fe-token-manage', title: 'App 令牌管理', type: 'perm', name: '令牌管理' }
    ]
  },
  {
    key: 'fe-live',
    title: '多窗口直播',
    type: 'folder',
    children: [
      { key: 'fe-live-page', title: '多窗口直播监控', type: 'perm', name: '多窗口直播监控' }
    ]
  },
  {
    key: 'fe-user',
    title: '用户中心',
    type: 'folder',
    children: [
      { key: 'fe-user-page', title: '用户中心页面', type: 'perm', name: '用户中心' }
    ]
  },
  {
    key: 'fe-devices',
    title: '设备管理',
    type: 'folder',
    children: [
      { key: 'fe-devices-page', title: '设备管理页面', type: 'perm', name: '设备管理' }
    ]
  }
];

/**
 * 历史兼容：早期访客/Locus 细权限，现已被页面级权限替代。
 * 仍挂在树上便于勾选迁移，不建议给新分组继续授权。
 */
export const LEGACY_PERMISSION_TREE = [
  {
    key: 'legacy-guest',
    title: '历史兼容（旧访客权限，建议迁移后删除）',
    type: 'folder',
    children: [
      {
        key: 'legacy-map',
        title: '【旧】查看地图 → 请改用「进入指挥系统页面」',
        type: 'perm',
        name: '查看地图'
      },
      {
        key: 'legacy-track',
        title: '【旧】查看历史轨迹 → 请改用「轨迹查询」或指挥轨迹能力',
        type: 'perm',
        name: '查看历史轨迹'
      },
      {
        key: 'legacy-devices',
        title: '【旧】查看设备列表 → 请改用「设备管理」或指挥系统',
        type: 'perm',
        name: '查看设备列表'
      },
      {
        key: 'legacy-ann',
        title: '【旧】查看公告 → 公告已对站点公开展示，一般无需再授权',
        type: 'perm',
        name: '查看公告'
      }
    ]
  }
];

/** 后台：与管理后台一级/二级菜单一致 */
export const BACKEND_PERMISSION_TREE = [
  {
    key: 'be-entry',
    title: '进入管理后台',
    type: 'folder',
    children: [
      { key: 'be-access', title: '管理后台访问', type: 'perm', name: '管理后台访问' }
    ]
  },
  {
    key: 'be-tools',
    title: '工具管理',
    type: 'folder',
    children: [
      { key: 'be-tools-main', title: '工具管理', type: 'perm', name: '工具管理' }
    ]
  },
  {
    key: 'be-members',
    title: '账号与队员',
    type: 'folder',
    children: [
      { key: 'be-users', title: '系统账号（用户管理）', type: 'perm', name: '用户管理' },
      { key: 'be-group-display', title: '账号列表显示分组', type: 'perm', name: '分组显示' },
      { key: 'be-members-info', title: '设备队员（会员信息）', type: 'perm', name: '会员信息管理' }
    ]
  },
  {
    key: 'be-perms',
    title: '权限管理',
    type: 'folder',
    children: [
      { key: 'be-groups', title: '分组管理', type: 'perm', name: '分组管理' },
      { key: 'be-perm-points', title: '权限点管理', type: 'perm', name: '权限管理' },
      { key: 'be-user-auth', title: '用户授权', type: 'perm', name: '用户授权' }
    ]
  },
  {
    key: 'be-ann',
    title: '公告管理',
    type: 'folder',
    children: [
      { key: 'be-ann-main', title: '公告管理', type: 'perm', name: '公告管理' }
    ]
  },
  {
    key: 'be-coord-hist',
    title: '转换历史管理',
    type: 'folder',
    children: [
      { key: 'be-coord-hist-main', title: '坐标转换历史管理', type: 'perm', name: '坐标转换历史管理' }
    ]
  },
  {
    key: 'be-products',
    title: '叠加图层',
    type: 'folder',
    children: [
      { key: 'be-products-main', title: '叠加图层（路网/等高线/航拍）', type: 'perm', name: '成品管理' },
      { key: 'be-panorama-manage', title: '全景影像管理', type: 'perm', name: '全景影像管理' }
    ]
  },
  {
    key: 'be-system',
    title: '系统设置',
    type: 'folder',
    children: [
      { key: 'be-system-main', title: '系统设置总入口', type: 'perm', name: '系统设置' },
      { key: 'be-homepage', title: '首页设置', type: 'perm', name: '首页设置' },
      { key: 'be-title', title: '标题栏设置', type: 'perm', name: '标题栏设置' },
      { key: 'be-org-brand', title: '队伍品牌文字设置', type: 'perm', name: '队伍品牌文字设置' },
      { key: 'be-navbar', title: '导航栏设置', type: 'perm', name: '导航栏设置' },
      {
        key: 'be-command-sys',
        title: '指挥系统设置',
        type: 'folder',
        children: [
          { key: 'be-command-pwd', title: '指挥系统密码', type: 'perm', name: '指挥系统密码' },
          { key: 'be-frontline', title: '前线队员设置', type: 'perm', name: '前线队员设置' },
          { key: 'be-track-mgmt', title: '轨迹数据管理', type: 'perm', name: '轨迹数据管理' },
          { key: 'be-phone-pick', title: '手机选点设置', type: 'perm', name: '手机选点设置' }
        ]
      },
      {
        key: 'be-map',
        title: '地图配置',
        type: 'folder',
        children: [
          { key: 'be-map-settings', title: '地图设置', type: 'perm', name: '地图设置' },
          { key: 'be-map-provider', title: '底图源设置', type: 'perm', name: '底图源设置' },
          { key: 'be-app-map', title: '单兵 App 设置', type: 'perm', name: '单兵 App 设置' },
          { key: 'be-icon-lib', title: '图标库管理', type: 'perm', name: '图标库管理' }
        ]
      },
      { key: 'be-admin-pwd', title: '管理员密码/会话设置', type: 'perm', name: '管理员密码管理' },
      { key: 'be-db', title: '数据库结构', type: 'perm', name: '数据库结构' }
    ]
  }
];

/** 明确废弃、不应再授权的权限名（会从「未归类」中隐藏，并可用 SQL 清理） */
export const OBSOLETE_PERMISSION_NAMES = new Set([
  '测试权限'
]);

function walkTree(nodes, visitor) {
  (nodes || []).forEach((node) => {
    visitor(node);
    if (node.children?.length) walkTree(node.children, visitor);
  });
}

export function collectCatalogPermissionNames() {
  const names = new Set();
  const collect = (tree) => {
    walkTree(tree, (n) => {
      if (n.type === 'perm' && n.name) names.add(n.name);
    });
  };
  collect(FRONTEND_PERMISSION_TREE);
  collect(BACKEND_PERMISSION_TREE);
  collect(LEGACY_PERMISSION_TREE);
  return names;
}

export function buildAntdTreeData(catalog, permByName) {
  const mapNode = (node) => {
    if (node.type === 'perm') {
      const perm = permByName.get(node.name);
      if (!perm) return null;
      const desc = perm.description ? ` — ${perm.description}` : '';
      return {
        key: `perm:${perm.id}`,
        title: `${node.title}${desc}`,
        isLeaf: true,
        permissionId: perm.id,
        permissionName: perm.name
      };
    }
    const children = (node.children || []).map(mapNode).filter(Boolean);
    if (children.length === 0) return null;
    return {
      key: node.key,
      title: node.title,
      children,
      checkable: true,
      selectable: false
    };
  };
  return (catalog || []).map(mapNode).filter(Boolean);
}

export function buildOtherTreeData(permissions, catalogNames) {
  const others = (permissions || []).filter(
    (p) => !catalogNames.has(p.name) && !OBSOLETE_PERMISSION_NAMES.has(p.name)
  );
  if (others.length === 0) return [];
  return [
    {
      key: 'other-root',
      title: '未归类权限点（库中存在、菜单树未收录，请核对后归类或删除）',
      children: others.map((p) => ({
        key: `perm:${p.id}`,
        title: p.description ? `${p.name} — ${p.description}` : p.name,
        isLeaf: true,
        permissionId: p.id,
        permissionName: p.name
      }))
    }
  ];
}

export function permissionIdsToTreeKeys(ids = []) {
  return ids.map((id) => `perm:${Number(id)}`);
}

export function treeKeysToPermissionIds(keys = []) {
  return keys
    .filter((k) => String(k).startsWith('perm:'))
    .map((k) => Number(String(k).slice(5)))
    .filter((id) => Number.isFinite(id));
}
